export default {
    previewData(state, getters, rootState) {
        if (!rootState.content.placeholders) {
            return state.formData;
        }

        return Object.assign(state.formData, rootState.content.placeholders.placeholderData);
    }
}